import React from 'react';
import { useFormik } from 'formik';

import AppButton from 'components/FormsUI/AppButton/appButton';
import { isAlphaNumericOnly } from 'utils/common-utils';

const validate = values => {
    const errors = {};
    if (!values.DocTypeMrz) {
        errors.DocTypeMrz = 'Required';
    } else if (values.DocTypeMrz.length > 2) {
        errors.DocTypeMrz = "Maximum digits are 2";
    }

    if (!values.Description) {
        errors.Description = 'Required';
    }
    return errors;
}

const onlyAlphaNumericHandle = (event, formik) => {
    if(event.target.value === "" || isAlphaNumericOnly(event.target.value)){
        formik.handleChange(event);
    }
}

export default function WriteDocTypeRow({ doctype, onSubmitted }) {
    const closeLine = () => { onSubmitted(null, "closeLine"); }
    const formik = useFormik({
        initialValues: {
            id: doctype?.id,
            DocTypeMrz: doctype?.docTypeMrz,
            Description: doctype?.description
        },
        validate,
        onSubmit: async (values) => {
            if (formik.isValid) {
                if (doctype) {
                    onSubmitted(values, "update");
                }
                else {
                    onSubmitted(values, "insert");
                }
            }
        }
    });
    return (
        <form onSubmit={formik.handleSubmit} >
            <div key={doctype?.id} className="row paddingLeftRight align-items-c border-bottom">
                <input id="id" name="id" type="hidden" value={formik.values.id} />
                <div className="col-md-2">
                    <input name="DocTypeMrz" id="DocTypeMrz" type="text"
                        onChange={(event) => onlyAlphaNumericHandle(event, formik)} value={formik.values.DocTypeMrz}
                        className="form-control" placeholder="DocTypeMrz"/>
                    {formik.touched.DocTypeMrz && formik.errors.DocTypeMrz ? <div className="alert alert-danger">{formik.errors.DocTypeMrz}</div> : null}
                </div>
                <div className="col-md-2">
                    <input name="Description" id="Description" type="text"
                        onChange={formik.handleChange} value={formik.values.Description}
                        className="form-control" placeholder="Description" />
                    {formik.touched.Description && formik.errors.Description ? <div className="alert alert-danger">{formik.errors.Description}</div> : null}
                </div>
                <div className="col-md-2">
                    <AppButton type="submit" label={doctype ? 'Submit' : 'Save'} classes="margingRight" ></AppButton>
                    <AppButton action={closeLine} label="X" color="danger"></AppButton>
                </div>
            </div>
        </form>
    )
}